export const ungroupEl = (self, g_el) => {
  self._checkNoProcessingTask();
  const grouping = self._getGroupingThrowable();
  return grouping.ungroup(g_el);
};
